// extracted by mini-css-extract-plugin
export default {"root":"IconHotel_root__j0S29"};